export default __webpack_public_path__ + "static/media/030106202140104.76efca5e.png";